var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloudy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 34,
    viewBox: "0 0 50 34",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Cloudy",
    transform: "translate(-3 -8.25)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_167390",
    "data-name": "Path 167390",
    d: "M36.638,45.25H11.422A12.683,12.683,0,0,1,3.5,42.844,9.4,9.4,0,0,1,0,35.135a9.226,9.226,0,0,1,3.14-7.11A12.593,12.593,0,0,1,9.5,25.173c.006,0,.009,0,.009-.006A17.037,17.037,0,0,1,14.927,15,15.237,15.237,0,0,1,25,11.25a14.474,14.474,0,0,1,8.8,2.886,15.15,15.15,0,0,1,4.546,5.653,1.719,1.719,0,0,0,1.206.957,14.086,14.086,0,0,1,7.022,3.613A11.61,11.61,0,0,1,50,32.839a11.884,11.884,0,0,1-3.988,8.981A13.962,13.962,0,0,1,36.638,45.25ZM38.685,20.581Z",
    transform: "translate(3 -3)",
    fill: "#b1b3b3"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudy);
export default __webpack_public_path__ + "static/media/cloudy.462af48b66a083537575eeab3c6022e5.svg";
export { ForwardRef as ReactComponent };